import { h } from 'preact'
import PropTypes from 'prop-types'
import Spinner from './Spinner'

const Spinnerable = ({ items, isLoading, children, ...rest }) => (
  <div {...rest}>
    {items.length === 0 && isLoading ? <Spinner /> : <div>{children}</div>}
  </div>
)

Spinnerable.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired
}

export default Spinnerable



// WEBPACK FOOTER //
// ./src/components/Spinnerable.js